export default __webpack_public_path__ + "static/media/mathias_l.dd5ec59a.jpg";